module.exports = __webpack_public_path__ + "img/html.340f8656.png";